"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBackendServer = exports.checkBrowser = void 0;
var hosts_1 = require("../config/hosts");
function checkBrowser() {
    return typeof window !== 'undefined';
}
exports.checkBrowser = checkBrowser;
function getBackendServer(env, language) {
    var isBrowser = checkBrowser();
    var hostConfig = hosts_1.HOSTS_CONFIG[env];
    if (!isBrowser) {
        return hostConfig.node;
    }
    return hostConfig.browser[language];
}
exports.getBackendServer = getBackendServer;
//# sourceMappingURL=common.js.map